import * as React from "react";
import { cn } from "@repo/utils/utils";
/**
 * Shared textarea with a consistent keyboard-submit contract:
 * - Cmd/Ctrl+Enter submits — calling `onSubmit` if given, otherwise
 *   requesting submit on the enclosing <form> (which runs native validation).
 * - Shift+Enter (and plain Enter) insert a newline, the native default.
 */
const Textarea = React.forwardRef(({ className, onSubmit, submitOnCmdEnter = true, onKeyDown, ...props }, ref) => {
    const handleKeyDown = (e) => {
        // Let a caller-supplied handler run first and opt out via preventDefault.
        onKeyDown?.(e);
        if (e.defaultPrevented)
            return;
        if (submitOnCmdEnter && (e.metaKey || e.ctrlKey) && e.key === "Enter") {
            e.preventDefault();
            if (onSubmit) {
                onSubmit();
            }
            else {
                e.currentTarget.form?.requestSubmit();
            }
        }
    };
    return (<textarea className={cn("flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base text-foreground shadow-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className)} ref={ref} onKeyDown={handleKeyDown} {...props}/>);
});
Textarea.displayName = "Textarea";
export { Textarea };
